import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[psCountryHoverableCellContent]',
})
export class CountryHoverableCellContentDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
